// extracted by mini-css-extract-plugin
module.exports = {"button":"SeePriceButton_button__NX0jd","hidden":"SeePriceButton_hidden__lRg9H"};